export const ENTITY_NAME = 'CORP_POLITY_'
export const POLITY_RULE = 'CORP_POLITY_RULE_'
export const POLITY_CONTACT = 'POLITY_CONTACT'
export const SET_TAB_POLICY = 'SET_TAB_POLICY'